import i18next from 'i18next'
import { Gender } from 'lib/_types'

export const YAY_DOMAIN = process.env.YAY_DOMAIN || '.yay.space'
export const isDev = process.env.NODE_ENV === 'development'
export const isStaging = process.env.ENV === 'staging'

export const stripeApiKey =
  window?.gon?.STRIPE_API_KEY || process.env.STRIPE_API_KEY
export const growthbookApiKey =
  window?.gon?.GROWTHBOOK_API_KEY || process.env.GROWTHBOOK_API_KEY
export const isChatWebsocketEnabled =
  window?.gon?.setting?.is_chat_websocket_enabled === '1'
export const supportLangs = ['ja', 'en', 'th', 'id', 'ko', 'zh-CN', 'zh-HK']
export const defaultLang = supportLangs[0]
export const allowedCreditCardBrands = [
  'mastercard',
  'visa',
  'jcb',
  'amex',
  'diners',
  'discover',
  'unionpay',
] as const

export const getCopyrightText = () =>
  `© ${new Date().getFullYear()} nanameue, Inc.`

export const MAX_PARTICIPANT_IN_CALL = {
  VIDEO: 8,
  VOICE: 18,
}

export const countryCodeList = [
  'JP',
  'US',
  'CN',
  'KR',
  'TW',
  'HK',
  'TH',
  'ID',
  'VN',
  'AU',
  'CA',
  'NZ',
  'SA',
  'others',
]

export const getCountryLabel = (countryCode: string) => {
  const countryMap = {
    AU: 'common.country.australia',
    CA: 'common.country.canada',
    ID: 'common.country.indonesia',
    JP: 'common.country.japan',
    NZ: 'common.country.new_zealand',
    SA: 'common.country.saudi_arabia',
    KR: 'common.country.south_korea',
    TW: 'common.country.taiwan',
    TH: 'common.country.thailand',
    US: 'common.country.usa',
    VN: 'common.country.vietnam',
    HK: 'common.country.hongkong',
    CN: 'common.country.china',
    others: 'common.other',
  }

  return i18next.t(countryMap[countryCode])
}

export const prefectureList = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
  '海外',
]

export const MAX_IMAGE_POST = 9
export const MAX_IMAGE_SHARED_POST = 3
const mb = 1024 * 1024
export const MAX_IMAGE_DIMENSION = 1920
export const MAX_IMAGE_SIZE = 5
export const MAX_IMAGE_SIZE_BYTE = MAX_IMAGE_SIZE * mb
export const MAX_TOTAL_IMAGE_SIZE = 10
export const MAX_TOTAL_IMAGE_SIZE_BYTE = MAX_TOTAL_IMAGE_SIZE * mb

// https://wiki.nanameue.jp/pages/viewpage.action?pageId=101811102
export const getAgeLimitRage = (age: number) => {
  if (age <= 12) {
    return {
      min: age,
      max: age + 2,
    }
  } else if (age <= 13) {
    return {
      min: age - 1,
      max: age + 2,
    }
  } else if (age <= 15) {
    return {
      min: age - 2,
      max: age + 3,
    }
  } else if (age <= 16) {
    return {
      min: age - 3,
      max: age + 3,
    }
  } else if (age <= 17) {
    return {
      min: age - 3,
      max: age + 4,
    }
  } else if (age <= 21) {
    return {
      min: age - 3,
      max: age + 200,
    }
  } else {
    return {
      min: 18,
      max: age + 200,
    }
  }
}

export const getGenderLabel = (gender: Gender) => {
  const GENDERS = {
    [Gender.UNSET]: i18next.t('common.not_set'),
    [Gender.MALE]: i18next.t('gender.male'),
    [Gender.FEMALE]: i18next.t('gender.female'),
  }

  return GENDERS[gender]
}

export const PASSWORD_LENGTH = {
  MIN: 8,
  MAX: 128,
}

export const MAX_GROUP_TOPIC_LENGTH = 26
export const MAX_GROUP_DESCRIPTION_LENGTH = 800
export const MAX_GROUP_GUIDELINES_LENGTH = 1000

export const GAME_CATEGORY_ID = 4

export const POLLING_INTERVAL = 10000
export const LOAD_NUMBER = window?.gon?.ENV === 'development' ? 15 : 50
export const LOAD_NUMBER_SMALL = window?.gon?.ENV === 'development' ? 10 : 20 // Some endpoints doesnt accept more than 20 numbers per page
